import {
    SET_PANORAMA_UI_IS_VISIBLE,
    SET_PANO_START_LAT_LON,
    SET_PANORAMA_BLURRED,
    SET_HOVERED_HOTSPOT_ID,
    SET_CURRENT_XY,
    PANORAMA_DRAG_START,
    PANORAMA_DRAG_END,
    PANO_AUTOROTATE_STARTED,
    PANO_AUTOROTATE_STOPPED,
    SET_FORCE_ROTATE,
    CLEAR_FORCE_ROTATE,
    SET_DRAG_HINT_DETAILS,
    REGISTER_PANO_PLAYER,
    SET_CURSOR,
} from 'aria-viewer/players/panoplayer/actions/panoramaActions'
import { CursorState } from '../constants'
import { Map } from 'immutable'

const INITIAL_STATE = Map({
    isPanoramaBlurred: false,
    isPanoUIVisible: true,
    isPanoAutoRotating: false,
    isUserDraggingPano: false,
    forceRotateParams: {
        lat: 0,
        lon: 0,
        forceRotate: false,
    },
    currentHoveredHotspotId: -1,
    panoStartLatLon: Map({
        lat: 0,
        lon: 180,
        isSetByTrigger: false,
    }),
    currentXY: Map({
        x: 0,
        y: 0,
        z: 0,
    }),
    draggingHint: Map({
        isVisible: true,
        delay: 5000,
        hintText: undefined,
    }),
    player: undefined,
    cursor: CursorState.GRAB,
})

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_CURSOR:
            return state.set('cursor', action.cursor)
        case SET_PANORAMA_UI_IS_VISIBLE:
            return state.set('isPanoUIVisible', action.visible)
        case SET_PANO_START_LAT_LON:
            return state.set('panoStartLatLon', action.values)
        case SET_PANORAMA_BLURRED:
            return state.set('isPanoramaBlurred', action.isPanoramaBlurred)
        case SET_HOVERED_HOTSPOT_ID:
            return state.set('currentHoveredHotspotId', action.id)
        case SET_CURRENT_XY:
            return state.set('currentXY', action.coords)
        case PANORAMA_DRAG_START:
            return state.set('isUserDraggingPano', true)
        case PANORAMA_DRAG_END:
            return state.set('isUserDraggingPano', false)
        case PANO_AUTOROTATE_STARTED:
            return state.set('isPanoAutoRotating', true)
        case PANO_AUTOROTATE_STOPPED:
            return state.set('isPanoAutoRotating', false)
        case SET_FORCE_ROTATE:
            return state.set('forceRotateParams', {
                lat: action.coords.lat,
                lon: action.coords.lon,
                forceRotate: true,
            })
        case CLEAR_FORCE_ROTATE:
            return state.set('forceRotateParams', {
                lat: null,
                lon: null,
                forceRotate: false,
            })
        case SET_DRAG_HINT_DETAILS: {
            return state.mergeIn(['draggingHint'], action.draggingHint)
        }
        case REGISTER_PANO_PLAYER: {
            const player = state.get('player')

            player && player.dispose()

            return state.withMutations(mState => {
                return mState
                    .set('player', {
                        setPosition: ({ lat, lon, speed = 60, cb }) =>
                            action.player.setPosition({ lat, lon }, { speed, cb }),

                        resetDeviceOrientationAlphaAngle: _ =>
                            action.player.panorama.camera.resetDeviceOrientationAlphaAngle(),

                        enableAccelerometerControls: enabled => action.player.enableAccelerometerControls(enabled),

                        getOptions: _ => action.player.options,

                        setSize: (width, height) => action.player.setSize(width, height),

                        getSize: () => ({
                            viewerHeight: action.player.viewerHeight,
                            viewerWidth: action.player.viewerWidth,
                        }),

                        setNeedsRefresh: _ => action.player.panorama.setNeedsRefresh(),

                        dispose: _ => (action.player = null),

                        getCameraOptions: _ => action.player.getCameraOptions(),

                        setAutoRotate: (on, autoRotateSpeed) => action.player.setAutoRotate(on, autoRotateSpeed),
                    })
                    .set('cursor', INITIAL_STATE.get('cursor'))
            })
        }
        default:
            return state
    }
}
